/** Horizontal funnel — visual only; values drive bar widths */
export default function FunnelChart({ stages = [], className = "" }) {
  const nums = stages.map((s) => Math.max(0, Number(s.value) || 0));
  const max = Math.max(1, ...nums);

  if (stages.length === 0) {
    return <div className={`funnel-chart funnel-chart--empty ${className}`}>No funnel data</div>;
  }

  return (
    <div className={`funnel-chart ${className}`}>
      {stages.map((stage, i) => {
        const v = nums[i];
        const pct = Math.round((v / max) * 100);
        const conv =
          i > 0 && nums[i - 1] > 0 ? `${((v / nums[i - 1]) * 100).toFixed(1)}%` : null;
        return (
          <div key={stage.label || i} className="funnel-chart-row">
            <div className="funnel-chart-labels">
              <span className="funnel-chart-name">{stage.label}</span>
              <span className="funnel-chart-meta">
                <strong>{stage.displayValue ?? v.toLocaleString()}</strong>
                {conv ? <span className="funnel-chart-conv">{conv} step</span> : null}
              </span>
            </div>
            <div className="funnel-chart-track">
              <div
                className="funnel-chart-fill"
                style={{ width: `${Math.max(8, pct)}%`, background: stage.color || "var(--accent)" }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
